import {
  atualizarStatusUsuarioSchema,
  atualizarUsuarioSchema,
  criarUsuarioSchema,
  listaDePapeisSchema,
  listaDeUsuariosSchema,
  usuarioDoPainelSchema,
  type AtualizarStatusUsuario,
  type AtualizarUsuario,
  type CriarUsuario,
  type ListaDePapeis,
  type ListaDeUsuarios,
  type UsuarioDoPainel,
} from "@base/contracts";
import type { ClienteHttp } from "../../../shared/http/cliente-http";

export type UsuariosGateway = {
  listar(consulta?: {
    readonly q?: string;
    readonly status?: "ativo" | "inativo" | "todos";
  }): Promise<ListaDeUsuarios>;
  listarPapeis(): Promise<ListaDePapeis>;
  criar(corpo: CriarUsuario): Promise<UsuarioDoPainel>;
  atualizar(id: string, corpo: AtualizarUsuario): Promise<UsuarioDoPainel>;
  atualizarStatus(
    id: string,
    corpo: AtualizarStatusUsuario,
  ): Promise<UsuarioDoPainel>;
};

export class UsuariosGatewayHttp implements UsuariosGateway {
  constructor(private readonly http: ClienteHttp) {}

  listar(consulta?: {
    readonly q?: string;
    readonly status?: "ativo" | "inativo" | "todos";
  }): Promise<ListaDeUsuarios> {
    return this.http.requisitar("/v1/usuarios", listaDeUsuariosSchema, {
      consulta: {
        ...(consulta?.q ? { q: consulta.q } : {}),
        ...(consulta?.status ? { status: consulta.status } : {}),
      },
    });
  }

  listarPapeis(): Promise<ListaDePapeis> {
    return this.http.requisitar("/v1/usuarios/papeis", listaDePapeisSchema);
  }

  criar(corpo: CriarUsuario): Promise<UsuarioDoPainel> {
    return this.http.requisitar("/v1/usuarios", usuarioDoPainelSchema, {
      metodo: "POST",
      corpo: criarUsuarioSchema.parse(corpo),
    });
  }

  atualizar(id: string, corpo: AtualizarUsuario): Promise<UsuarioDoPainel> {
    return this.http.requisitar(`/v1/usuarios/${id}`, usuarioDoPainelSchema, {
      metodo: "PATCH",
      corpo: atualizarUsuarioSchema.parse(corpo),
    });
  }

  atualizarStatus(
    id: string,
    corpo: AtualizarStatusUsuario,
  ): Promise<UsuarioDoPainel> {
    return this.http.requisitar(
      `/v1/usuarios/${id}/status`,
      usuarioDoPainelSchema,
      {
        metodo: "PATCH",
        corpo: atualizarStatusUsuarioSchema.parse(corpo),
      },
    );
  }
}
